<template>
  <div>
    <div style="margin: 15px">
      <h5>{{ $t("sms.nombreMessageParCategorie") }}</h5>
    </div>

    <!--begin::Chart-->
    <apexchart
      class="statistics-widget-3-chart card-rounded-bottom"
      :options="options"
      :series="series"
      :height="300"
      type="bar"
    ></apexchart>
    <!--end::Chart-->
  </div>
</template>

<script>
export default {
  props: ["data"],
  data() {
    return {
      options: {},
      series: [],
      labelColor: "#3F4254",
      colors: ["#0095E8", "#67c23a", "#D9214E", "#feb019"],
      lightColors: ["#FFF5F8", "#e8fff3", "#F1FAFF"],
    };
  },
  watch: {
    data: function (value) {
      this.updateChart();
    },
  },
  created() {
    this.updateChart();
  },
  methods: {
    updateChart() {
      if (!this.data || !Array.isArray(this.data)) {
        this.series = [{ name: this.$t("sms.nombreMessage"), type: "bar", data: [] }];
        this.options = { xaxis: { categories: [] }, yaxis: { min: 0, max: 3 } };
        return;
      }
      const tags = {};
      const tagsSerie = [];
      const data = [];

      this.data.forEach((message) => {
        const tagList = Array.isArray(message.tags)
          ? message.tags
          : message.tags != null && message.tags !== ""
            ? [String(message.tags)]
            : [];
        const count = message.totalSMSRSent ?? message.totalSMSClientCalculated ?? 1;
        tagList.forEach((tag) => {
          if (!tags[tag]) tags[tag] = count;
          else tags[tag] += count;
        });
      });

      for (const tag of Object.keys(tags)) {
        tagsSerie.push(tag);
        data.push(tags[tag]);
      }

      this.updateSeries(data);
      this.updateOptions(tagsSerie, data);
    },
    updateSeries(data) {
      this.series = [
        {
          name: this.$t("sms.nombreMessage"),
          type: "bar",
          data,
        },
      ];
    },
    updateOptions(tagsSerie, data) {
      this.options = {
        chart: {
          height: 350,
          type: "bar",
          toolbar: {
            show: false,
          },
        },
        theme: {
          monochrome: {
            enabled: true,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: tagsSerie,
          labels: {
            style: {
              fontSize: "13px",
            },
          },
        },
        yaxis: {
          min: 0,
          max: data.length ? Math.max(...data) + 3 : 3,
          labels: {
            formatter: function (val) {
              return val.toFixed(0);
            },
          },
        },
      };
    },
  },
};
</script>
